interface adSlotPrebid {
    appnexus: appnexusPlacementId,
    pubmatic: pubmaticFormat,
    freewheel: freewheelFormat,
    fw: fwFormat,
    pubmatic_apex: pubmaticFormat,
    taboola: taboolaFormat,
    improve: improveFormat,
    rubicon: rubiconFormat,
    seedtag: seedtagFormat,
    ix: ixFormat,
    criteo: criteoFormat,
    mobkoi: mobkoiFormat,
    yobee: yobeeFormat,
    ogury: oguryFormat,
    missena: missenaFormat,
    ttd: ttdFormat
    connectAd: connectAdFormat
    ozone: ozoneFormat
}


interface connectAdFormat {
    display: any,
}
interface ttdFormat {
    display: any,
    video: any
}
interface missenaFormat {
    display: any,
}
interface taboolaFormat {
    display: any
}
interface mobkoiFormat {
    display: any,
}
interface seedtagFormat {
    display: any,
    video: any
}

interface ixFormat {
    display: any,
    video: any
}

interface criteoFormat {
    display: any,
    video: any
}

interface rubiconFormat {
    display: any,
    video: any
}
interface improveFormat {
    video: any
}

interface appnexusPlacementId {
    display: any
    video: any
    code: any
}

interface yobeeFormat {
    display: any,
    video: any
}

interface pubmaticFormat {
    display: any,
    video: any
}

interface freewheelFormat {
    zoneId: Record<string, string>;
}

interface fwFormat {
    video: any
}

interface oguryFormat {
    display: any
}
interface ozoneFormat {
    display: any,
    video: any
}
//overlayer appnexus

export const adSlotPrebid: adSlotPrebid = {
    freewheel: {
        zoneId: {
            fanpage_video: '33905290',
            ck_it_video: '33905292',
            geopop_video: '33905308',
            ck_wow_video: '33905294',
            ohga_video: '33905312',
            kodami_video: '33905310',
            wamily_video: '33905290',
            lexplain_video: '33905314'
        }
    },
    fw: {
        video: {
            fanpage_video: {
                siteSectionId: '3456217',
                networkId: '536054',
                profile: '536054:fw_ssp_prebidjs_ciaopeoplenetwork',
            },
            ck_it_video: {
                siteSectionId: '23498488',
                networkId: '536054',
                profile: '536054:fw_ssp_prebidjs_ciaopeoplenetwork',

            },
            geopop_video: {
                siteSectionId: '23498490',
                networkId: '536054',
                profile: '536054:fw_ssp_prebidjs_ciaopeoplenetwork',

            },
            ck_wow_video: {
                siteSectionId: '23498489',
                networkId: '536054',
                profile: '536054:fw_ssp_prebidjs_ciaopeoplenetwork',

            },
            kodami_video: {
                siteSectionId: '23498487',
                networkId: '536054',
                profile: '536054:fw_ssp_prebidjs_ciaopeoplenetwork',

            },
            wamily_video: {
                siteSectionId: '3456217',
                networkId: '536054',
                profile: '536054:fw_ssp_prebidjs_ciaopeoplenetwork',

            },
            lexplain_video: {
                siteSectionId: '23498491',
                networkId: '536054',
                profile: '536054:fw_ssp_prebidjs_ciaopeoplenetwork',

            }
        }

    },
    missena: {
        display: {
            go_interstitial: {
                apiKey: 'PA-57557322',
                gpid: '/1010633/go_interstitial',
                placement: "prestitial",
            },
            fanpage_inarticle: {
                apiKey: 'PA-57557322',
                gpid: '/1010633/fanpage_inarticle',
                placement: "infeed",
            },
            fpmobile_leadeboard: {
                apiKey: 'PA-57557322',
                gpid: '/1010633/fpmobile_leadeboard',
                placement: "infeed.s",
            },
            fpmobile_300x250_top: {
                apiKey: 'PA-57557322',
                gpid: '/1010633/fpmobile_300x250_top',
                placement: "infeed",
            },
            fpmobile_300x250: {
                apiKey: 'PA-57557322',
                gpid: '/1010633/fpmobile_300x250',
                placement: "infeed",
            },
            fpmobile_fplayer: {
                apiKey: 'PA-57557322',
                gpid: '/1010633/fpmobile_fplayer',
                placement: "infeed",
            },
            fpmobile_300x250_bottom: {
                apiKey: 'PA-57557322',
                gpid: '/1010633/fpmobile_300x250_bottom',
                placement: "infeed",
            },
            geopop_inarticle: {
                apiKey: 'PA-95333687',
                gpid: '/1010633/geopop_inarticle',
                placement: "infeed",
            },
            geopop_leaderboard: {
                apiKey: 'PA-95333687',
                gpid: '/1010633/geopop_leaderboard',
                placement: "infeed.s",
            },
            geopop_top: {
                apiKey: 'PA-95333687',
                gpid: '/1010633/geopop_top',
                placement: "infeed",
            },
            geopop_middle: {
                apiKey: 'PA-95333687',
                gpid: '/1010633/geopop_middle',
                placement: "infeed",
            },
            geopop_fplayer: {
                apiKey: 'PA-95333687',
                gpid: '/1010633/geopop_fplayer',
                placement: "infeed",
            },
            geopop_fplayer2: {
                apiKey: 'PA-95333687',
                gpid: '/1010633/geopop_fplayer2',
                placement: "infeed",
            },
            geopop_fplayer3: {
                apiKey: 'PA-95333687',
                gpid: '/1010633/geopop_fplayer3',
                placement: "infeed",
            },
            geopop_fplayer4: {
                apiKey: 'PA-95333687',
                gpid: '/1010633/geopop_fplayer4',
                placement: "infeed",
            },
            geopop_bottom: {
                apiKey: 'PA-95333687',
                gpid: '/1010633/geopop_bottom',
                placement: "infeed",
            },
            cookist_it_inarticle: {
                apiKey: 'PA-81815522',
                gpid: '/1010633/cookist_it_inarticle',
                placement: "infeed",
            },
            ck_it_mobile_leadeboard: {
                apiKey: 'PA-81815522',
                gpid: '/1010633/cookist_it_mobile_leadeboard',
                placement: "infeed.s",
            },
            ck_it_mobile_300x250_top: {
                apiKey: 'PA-81815522',
                gpid: '/1010633/ck_it_mobile_300x250_top',
                placement: "infeed",
            },
            ck_it_mobile_300x250: {
                apiKey: 'PA-81815522',
                gpid: '/1010633/ck_it_mobile_300x250',
                placement: "infeed",
            },
            ck_it_mobile_fplayer: {
                apiKey: 'PA-81815522',
                gpid: '/1010633/ck_it_mobile_fplayer',
                placement: "infeed",
            },
            ck_it_mobile_fplayer2: {
                apiKey: 'PA-81815522',
                gpid: '/1010633/ck_it_mobile_fplayer2',
                placement: "infeed",
            },
            ck_it_mobile_fplayer3: {
                apiKey: 'PA-81815522',
                gpid: '/1010633/ck_it_mobile_fplayer3',
                placement: "infeed",
            },
            ck_it_mobile_fplayer4: {
                apiKey: 'PA-81815522',
                gpid: '/1010633/ck_it_mobile_fplayer4',
                placement: "infeed",
            },
            ck_it_mobile_300x250_bottom: {
                apiKey: 'PA-81815522',
                gpid: '/1010633/ck_it_mobile_300x250_bottom',
                placement: "infeed",
            },
            ckmobile_leaderboard: {
                apiKey: 'PA-93288917',
                gpid: '/1010633/ckmobile_leaderboard',
                placement: "infeed.s",
            },
            ckmobile_300x250_top: {
                apiKey: 'PA-93288917',
                gpid: '/1010633/ckmobile_300x250_top',
                placement: "infeed",
            },
            ckmobile_300x250: {
                apiKey: 'PA-93288917',
                gpid: '/1010633/ckmobile_300x250',
                placement: "infeed",
            },
            ckmobile_fplayer: {
                apiKey: 'PA-93288917',
                gpid: '/1010633/ckmobile_fplayer',
                placement: "infeed",
            },
            ckmobile_300x250_bottom: {
                apiKey: 'PA-93288917',
                gpid: '/1010633/ckmobile_300x250_bottom',
                placement: "infeed",
            },
            lexplain_leaderboard: {
                apiKey: 'PA-57857748',
                gpid: '/1010633/lexplain_leaderboard',
                placement: "infeed.s",
            },
        }
    },
    ttd: {
        display: {
            fanpage_inarticle: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/fanpage_inarticle"
            },
            cookist_it_inarticle: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/cookist_it_inarticle"
            },
            geopop_inarticle: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/geopop_inarticle"
            },
            fpmobile_leadeboard: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/fpmobile_leadeboard"
            },
            fpmobile_300x250_top: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/fpmobile_300x250_top"
            },
            fpmobile_300x250: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/fpmobile_300x250"
            },
            fpmobile_fplayer: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/fpmobile_fplayer"
            },
            fpmobile_300x250_bottom: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/fpmobile_300x250_bottom"
            },
            ck_it_mobile_leadeboard: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ck_it_mobile_leadeboard"
            },
            ck_it_mobile_300x250_top: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ck_it_mobile_300x250_top"
            },
            ck_it_mobile_300x250: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ck_it_mobile_300x250"
            },
            ck_it_mobile_fplayer: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ck_it_mobile_fplayer"
            },
            ck_it_mobile_fplayer2: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ck_it_mobile_fplayer2"
            },
            ck_it_mobile_fplayer3: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ck_it_mobile_fplayer3"
            },
            ck_it_mobile_fplayer4: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ck_it_mobile_fplayer4"
            },
            ck_it_mobile_300x250_bottom: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ck_it_mobile_300x250_bottom"
            },
            ohga_header: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ohga_header"
            },
            ohga_300x250_top: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ohga_300x250_top"
            },
            ohga_300x250_middle: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ohga_300x250_middle"
            },
            ohga_low: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ohga_low"
            },
            ohga_bottom: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ohga_bottom"
            },
            geopop_leaderboard: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/geopop_leaderboard"
            },
            geopop_top: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/geopop_top"
            },
            geopop_middle: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/geopop_middle"
            },
            geopop_fplayer: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/geopop_fplayer"
            },
            geopop_fplayer2: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/geopop_fplayer2"
            },
            geopop_fplayer3: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/geopop_fplayer3"
            },
            geopop_fplayer4: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/geopop_fplayer4"
            },
            geopop_bottom: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/geopop_bottom"
            },
            ckmobile_leaderboard: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ckmobile_leaderboard"
            },
            ckmobile_300x250_top: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ckmobile_300x250_top"
            },
            ckmobile_300x250: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ckmobile_300x250"
            },
            ckmobile_fplayer: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ckmobile_fplayer"
            },
            ckmobile_300x250_bottom: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ckmobile_300x250_bottom"
            },
            kodami_header: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/kodami_header"
            },
            kodami_top: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/kodami_top"
            },
            kodami_middle: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/kodami_middle"
            },
            kodami_low: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/kodami_low"
            },
            kodami_bottom: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/kodami_bottom"
            }
        },
        video: {
            fanpage_video: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/fanpage_video"
            },
            ck_it_video: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ck_it_video"
            },
            ck_wow_video: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ck_wow_video"
            },
            ck_legal_video: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ck_legal_video"
            },
            ohga_video: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ohga_video"
            },
            kodami_video: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/kodami_video"
            },
            geopop_video: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/geopop_video"
            },
            wamily_video: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/wamily_video"
            },
            lexplain_video: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/lexplain_video"
            }
        }
    },
    yobee: {
        display: {
            fanpage_inarticle: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/fanpage_inarticle"
            },
            cookist_it_inarticle: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/cookist_it_inarticle"
            },
            geopop_inarticle: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_inarticle"
            },
            fpmobile_leadeboard: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/fpmobile_leadeboard"
            },
            fpmobile_300x250_top: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/fpmobile_300x250_top"
            },
            fpmobile_300x250: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/fpmobile_300x250"
            },
            fpmobile_fplayer: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/fpmobile_fplayer"
            },
            fpmobile_300x250_bottom: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/fpmobile_300x250_bottom"
            },
            ck_it_mobile_leadeboard: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_it_mobile_leadeboard"
            },
            ck_it_mobile_300x250_top: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_it_mobile_300x250_top"
            },
            ck_it_mobile_300x250: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_it_mobile_300x250"
            },
            ck_it_mobile_fplayer: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_it_mobile_fplayer"
            },
            ck_it_mobile_fplayer2: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_it_mobile_fplayer2"
            },
            ck_it_mobile_fplayer3: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_it_mobile_fplayer3"
            },
            ck_it_mobile_fplayer4: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_it_mobile_fplayer4"
            },
            ck_it_mobile_300x250_bottom: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_it_mobile_300x250_bottom"
            },
            ohga_header: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ohga_header"
            },
            ohga_300x250_top: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ohga_300x250_top"
            },
            ohga_300x250_middle: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ohga_300x250_middle"
            },
            ohga_low: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ohga_low"
            },
            ohga_bottom: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ohga_bottom"
            },
            geopop_leaderboard: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_leaderboard"
            },
            geopop_top: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_top"
            },
            geopop_middle: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_middle"
            },
            geopop_fplayer: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_fplayer"
            },
            geopop_fplayer2: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_fplayer2"
            },
            geopop_fplayer3: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_fplayer3"
            },
            geopop_fplayer4: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_fplayer4"
            },
            geopop_bottom: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_bottom"
            },
            ckmobile_leaderboard: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ckmobile_leaderboard"
            },
            ckmobile_300x250_top: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ckmobile_300x250_top"
            },
            ckmobile_300x250: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ckmobile_300x250"
            },
            ckmobile_fplayer: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ckmobile_fplayer"
            },
            ckmobile_300x250_bottom: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ckmobile_300x250_bottom"
            },
            kodami_header: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/kodami_header"
            },
            kodami_top: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/kodami_top"
            },
            kodami_middle: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/kodami_middle"
            },
            kodami_low: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/kodami_low"
            },
            kodami_bottom: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/kodami_bottom"
            }
        },
        video: {
            fanpage_video: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/fanpage_video"
            },
            ck_it_video: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_it_video"
            },
            ck_wow_video: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_wow_video"
            },
            ck_legal_video: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_legal_video"
            },
            ohga_video: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ohga_video"
            },
            kodami_video: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/kodami_video"
            },
            geopop_video: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_video"
            },
            wamily_video: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/wamily_video"
            },
            lexplain_video: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/lexplain_video"
            }
        }
    },
    appnexus: {
        code: {
            fanpage_video: 'fanpage.it_video',
            ck_it_video: 'cookist.it_video',
            ck_wow_video: 'cookist.com_video',
            ck_legal_video: 'cookist.com_video',
            ohga_video: 'ohga.it_video',
            kodami_video: 'kodami.it_video',
            geopop_video: 'geopop.it_video',
            wamily_video: 'fanpage.it_video',
            lexplain_video: 'fanpage.it_video',
        },
        display: {
            fanpage_inarticle: {
                placementId: 35179082,
                gpid: '/1010633/fanpage_inarticle'
            },
            cookist_it_inarticle: {
                placementId: 35282059,
                gpid: '/1010633/cookist_it_inarticle'
            },
            geopop_inarticle: {
                placementId: 35281646,
                gpid: '/1010633/geopop_inarticle'
            },
            ckmobile_300x250: {
                placementId: 12680661,
                gpid: '/1010633/ckmobile_300x250'
            },
            ckmobile_300x250_bottom: {
                placementId: 12680662,
                gpid: '/1010633/ckmobile_300x250_bottom'
            },
            ckmobile_300x250_top: {
                placementId: 24485986,
                gpid: '/1010633/ckmobile_300x250_top'
            },
            ckmobile_fplayer: {
                placementId: 12680663,
                gpid: '/1010633/ckmobile_fplayer'
            },
            ckmobile_leaderboard: {
                placementId: 12680664,
                gpid: '/1010633/ckmobile_leaderboard'
            },
            cookist_mobile_300x250_bottom: {
                placementId: 12680672,
                gpid: '/1010633/cookist_mobile_300x250_bottom'
            },
            cookist_mobile_300x250: {
                placementId: 12680671,
                gpid: '/1010633/cookist_mobile_300x250'
            },
            cookist_mobile_leaderboard: {
                placementId: 12680673,
                gpid: '/1010633/cookist_mobile_leaderboard'
            },
            ck_it_mobile_300x250: {
                placementId: 17835634,
                gpid: '/1010633/ck_it_mobile_300x250'
            },
            ck_it_mobile_300x250_bottom: {
                placementId: 17835635,
                gpid: '/1010633/ck_it_mobile_300x250_bottom'
            },
            ck_it_mobile_300x250_top: {
                placementId: 17835633,
                gpid: '/1010633/ck_it_mobile_300x250_top'
            },
            ck_it_mobile_fplayer: {
                placementId: 17835636,
                gpid: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_leadeboard: {
                placementId: 17835639,
                gpid: '/1010633/ck_it_mobile_leadeboard'
            },
            cookist_it_mobile_300x250: {
                placementId: 17835640,
                gpid: '/1010633/cookist_it_mobile_300x250'
            },
            cookist_it_mobile_300x250_bottom: {
                placementId: 17835642,
                gpid: '/1010633/cookist_it_mobile_300x250_bottom'
            },
            cookist_it_mobile_leaderboard: {
                placementId: 17835643,
                gpid: '/1010633/cookist_it_mobile_leaderboard'
            },
            fpmobile_300x250: {
                placementId: 12680682,
                gpid: '/1010633/fpmobile_300x250'
            },
            fpmobile_300x250_bottom: {
                placementId: 12680683,
                gpid: '/1010633/fpmobile_300x250_bottom'
            },
            fpmobile_300x250_top: {
                placementId: 16638781,
                gpid: '/1010633/fpmobile_300x250_top'
            },
            fpmobile_fplayer: {
                placementId: 12680684,
                gpid: '/1010633/fpmobile_fplayer'
            },
            fpmobile_leadeboard: {
                placementId: 12680685,
                gpid: '/1010633/fpmobile_leadeboard'
            },
            geopop_bottom: {
                placementId: 22777855,
                gpid: '/1010633/geopop_bottom'
            },
            geopop_fplayer: {
                placementId: 22777856,
                gpid: '/1010633/geopop_fplayer'
            },
            geopop_leaderboard: {
                placementId: 22777853,
                gpid: '/1010633/geopop_leaderboard'
            },
            geopop_middle: {
                placementId: 22777854,
                gpid: '/1010633/geopop_middle'
            },
            geopop_top: {
                placementId: 22777849,
                gpid: '/1010633/geopop_top'
            },
            go_interstitial: {
                placementId: 24514163,
                gpid: '/1010633/go_interstitial',
                instl: 1,
                ...(typeof document !== 'undefined' && document.body && document.body.classList.contains('postid-121252') ? { outstream: 1 } : {})
            },
            kodami_bottom: {
                placementId: 20791657,
                gpid: '/1010633/kodami_bottom'
            },
            kodami_header: {
                placementId: 20791624,
                gpid: '/1010633/kodami_header'
            },
            kodami_low: {
                placementId: 20791653,
                gpid: '/1010633/kodami_low'
            },
            kodami_middle: {
                placementId: 20791644,
                gpid: '/1010633/kodami_middle'
            },
            kodami_top: {
                placementId: 20791626,
                gpid: '/1010633/kodami_top'
            },
            Lexplain_bottom: {
                placementId: 30100306,
                gpid: '/1010633/Lexplain_bottom'
            },
            Lexplain_fplayer: {
                placementId: 30100304,
                gpid: '/1010633/Lexplain_fplayer'
            },
            Lexplain_leaderboard: {
                placementId: 30100305,
                gpid: '/1010633/Lexplain_leaderboard'
            },
            Lexplain_middle: {
                placementId: 30100303,
                gpid: '/1010633/Lexplain_middle'
            },
            Lexplain_top: {
                placementId: 30088229,
                gpid: '/1010633/Lexplain_top'
            },
            ohga_300x250_middle: {
                placementId: 14194519,
                gpid: '/1010633/ohga_300x250_middle'
            },
            ohga_300x250_top: {
                placementId: 14194517,
                gpid: '/1010633/ohga_300x250_top'
            },
            ohga_bottom: {
                placementId: 18288318,
                gpid: '/1010633/ohga_bottom'
            },
            ohga_header: {
                placementId: 14194515,
                gpid: '/1010633/ohga_header'
            },
            ohga_low: {
                placementId: 24485693,
                gpid: '/1010633/ohga_low'
            },
        },
        video: {
            fanpage_video: {
                placementId: 12957535,
                gpid: '/1010633/fanpage_video'
            },
            ck_it_video: {
                placementId: 17835664,
                gpid: '/1010633/ck_it_video'
            },
            geopop_video: {
                placementId: 22777858,
                gpid: '/1010633/geopop_video'
            },
            ck_wow_video: {
                placementId: 13108461,
                gpid: '/1010633/ck_wow_video'
            },
            ohga_video: {
                placementId: 14194524,
                gpid: '/1010633/ohga_video'
            },
            kodami_video: {
                placementId: 20791665,
                gpid: '/1010633/kodami_video'
            },
            wamily_video: {
                placementId: 12957535,
                gpid: '/1010633/wamily_video'
            },
            lexplain_video: {
                placementId: 12957535,
                gpid: '/1010633/lexplain_video'
            }
        }

    },
    mobkoi: {
        display: {
            ck_it_mobile_fplayer: {
                placementId: 'F5FFF769',
                gpid: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_fplayer2: {
                placementId: 'A58DC887',
                gpid: '/1010633/ck_it_mobile_fplayer2'
            },
            ck_it_mobile_fplayer3: {
                placementId: 'A58DC887',
                gpid: '/1010633/ck_it_mobile_fplayer3'
            },
            ck_it_mobile_fplayer4: {
                placementId: 'F5FFF769',
                gpid: '/1010633/ck_it_mobile_fplayer4'
            },
            ck_it_mobile_300x250: {
                placementId: 'A58DC887',
                gpid: '/1010633/ck_it_mobile_300x250'
            },
            ck_it_mobile_300x250_bottom: {
                placementId: 'A58DC887',
                gpid: '/1010633/ck_it_mobile_300x250_bottom'
            },
            ck_it_mobile_300x250_top: {
                placementId: 'F5FFF769',
                gpid: '/1010633/ck_it_mobile_300x250_top'
            },
            cookist_it_inarticle: {
                placementId: 'A58DC887',
                gpid: '/1010633/cookist_it_inarticle'
            },
            ckmobile_300x250: {
                placementId: 'F1C6C071',
                gpid: '/1010633/ckmobile_300x250'
            },
            ckmobile_300x250_top: {
                placementId: 'F93D37A2',
                gpid: '/1010633/ckmobile_300x250_top'
            },
            ckmobile_300x250_bottom: {
                placementId: 'F93D37A2',
                gpid: '/1010633/ckmobile_300x250_bottom'
            },
            ckmobile_fplayer: {
                placementId: 'F93D37A2',
                gpid: '/1010633/ckmobile_fplayer'
            },
            geopop_middle: {
                placementId: 'B3DCAABC',
                gpid: '/1010633/geopop_middle'
            },
            geopop_bottom: {
                placementId: 'B3DCAABC',
                gpid: '/1010633/geopop_bottom'
            },
            geopop_fplayer: {
                placementId: 'F93D37A2',
                gpid: '/1010633/geopop_fplayer'
            },
            ckmobile_fplayer2: {
                placementId: 'A52D20ED',
                gpid: '/1010633/ckmobile_fplayer2'
            },
            ckmobile_fplayer3: {
                placementId: 'A52D20ED',
                gpid: '/1010633/ckmobile_fplayer3'
            },
            ckmobile_fplayer4: {
                placementId: 'B3DCAABC',
                gpid: '/1010633/ckmobile_fplayer4'
            },
            geopop_top: {
                placementId: 'B3DCAABC',
                gpid: '/1010633/geopop_top'
            },
            geopop_inarticle: {
                placementId: 'B3DCAABC',
                gpid: '/1010633/geopop_inarticle'
            },
            fanpage_inarticle: {
                placementId: 'DEFA3CDA',
                gpid: '/1010633/fanpage_inarticle'
            },
            fpmobile_300x250: {
                placementId: 'DEFA3CDA',
                gpid: '/1010633/fpmobile_300x250'
            },
            fpmobile_300x250_top: {
                placementId: 'C680A2D5',
                gpid: '/1010633/fpmobile_300x250_top'
            },
            fpmobile_300x250_bottom: {
                placementId: 'C680A2D5',
                gpid: '/1010633/fpmobile_300x250_bottom'
            },
            fpmobile_fplayer: {
                placementId: 'C680A2D5',
                gpid: '/1010633/fpmobile_fplayer'
            },
            kodami_middle: {
                placementId: 'F8D3D235',
                gpid: '/1010633/kodami_middle'
            },
            kodami_bottom: {
                placementId: 'F8D3D235',
                gpid: '/1010633/kodami_bottom'
            },
            kodami_inarticle: {
                placementId: 'E3FA868D',
                gpid: '/1010633/kodami_inarticle'
            },
            kodami_low: {
                placementId: 'E3FA868D',
                gpid: '/1010633/kodami_low'
            },
            kodami_top: {
                placementId: 'E3FA868D',
                gpid: '/1010633/kodami_top'
            },
        },
    },
    taboola: {
        display: {
            //kodami_overlayer: {
            //    publisherId: '1816501',
            //},
            fpmobile_300x250: {
                publisherId: '1816501',
            },
            fpmobile_300x250_top: {
                publisherId: '1816501',
            },
            fpmobile_leadeboard: {
                publisherId: '1816501',
            },
            //inarticle
            fanpage_inarticle: {
                publisherId: '1816501',
            },
            cookist_it_inarticle: {
                publisherId: '1816509',
            },
            geopop_inarticle: {
                publisherId: '1816505',
            },
            fpmobile_fplayer: {
                publisherId: '1816501',
            },
            fpmobile_fplayer2: {
                publisherId: '1816501',
            },
            fpmobile_fplayer3: {
                publisherId: '1816501',
            },
            fpmobile_fplayer4: {
                publisherId: '1816501',
            },
            ck_it_mobile_fplayer2: {
                publisherId: '1816509',
            },
            ck_it_mobile_fplayer3: {
                publisherId: '1816509',
            },
            ck_it_mobile_fplayer4: {
                publisherId: '1816509',
            },
            ck_it_mobile_300x250_bottom: {
                publisherId: '1816509',
            },
            geopop_fplayer: {
                publisherId: '1816505',
            },
            geopop_fplayer2: {
                publisherId: '1816505',
            },
            geopop_fplayer3: {
                publisherId: '1816505',
            },
            geopop_fplayer4: {
                publisherId: '1816505',
            },
            geopop_bottom: {
                publisherId: '1816505',
            },
            ckmobile_300x250: {
                publisherId: '1816509',
            },
            ckmobile_300x250_bottom: {
                publisherId: '1816509',
            },
            ckmobile_300x250_top: {
                publisherId: '1816509',
            },
            ckmobile_fplayer: {
                publisherId: '1838467',
            },
            ckmobile_leaderboard: {
                publisherId: '1838467',
            },
            cookist_mobile_300x250_bottom: {
                publisherId: '1838467',
            },
            cookist_mobile_300x250: {
                publisherId: '1838467',
            },
            cookist_mobile_leaderboard: {
                publisherId: '1838467',
            },
            ck_it_mobile_300x250: {
                publisherId: '1816509',
            },
            ck_it_mobile_300x250_top: {
                publisherId: '1816509',
            },
            ck_it_mobile_fplayer: {
                publisherId: '1816509',
            },
            ck_it_mobile_leadeboard: {
                publisherId: '1816509',
            },
            cookist_it_mobile_300x250: {
                publisherId: '1816509',
            },
            cookist_it_mobile_300x250_bottom: {
                publisherId: '1816509',
            },
            cookist_it_mobile_leaderboard: {
                publisherId: '1816509',
            },
            geopop_leaderboard: {
                publisherId: '1816505',
            },
            geopop_middle: {
                publisherId: '1816505',
            },
            geopop_top: {
                publisherId: '1816505',
            },


        }
    },
    improve: {
        video: {
            fanpage_video: {
                placementId: 23319251,
                publisherId: 1993
            },
            ck_it_video: {
                placementId: 23319278,
                publisherId: 1993
            },
            ck_wow_video: {
                placementId: 23319278,
                publisherId: 1993
            },
            ck_legal_video: {
                placementId: 23319278,
                publisherId: 1993
            },
            geopop_video: {
                placementId: 23319279,
                publisherId: 1993
            },
        }
    },
    connectAd: {
        display: {
            fpmobile_300x250: {
                siteId: 3205790,
                networkId: 564,
                gpid: '/1010633/fpmobile_300x250'
            },
            fpmobile_300x250_bottom: {
                siteId: 3205791,
                networkId: 564,
                gpid: '/1010633/fpmobile_300x250_bottom'
            },
            fpmobile_fplayer: {
                siteId: 3205792,
                networkId: 564,
                gpid: '/1010633/fpmobile_fplayer'
            },
            fpmobile_300x250_top: {
                siteId: 3205793,
                networkId: 564,
                gpid: '/1010633/fpmobile_300x250_top'
            },
            //fpmobile_leadeboard: {
            //    siteId: 3205794,
            //    networkId: 564,
            //    gpid: '/1010633/fpmobile_leadeboard'
            //},
            fanpage_inarticle: {
                siteId: 3205795,
                networkId: 564,
                gpid: '/1010633/fanpage_inarticle'
            },
            ck_it_mobile_300x250: {
                siteId: 3205796,
                networkId: 564,
                gpid: '/1010633/ck_it_mobile_300x250'
            },
            ck_it_mobile_300x250_bottom: {
                siteId: 3205797,
                networkId: 564,
                gpid: '/1010633/ck_it_mobile_300x250_bottom'
            },
            ck_it_mobile_300x250_top: {
                siteId: 3205798,
                networkId: 564,
                gpid: '/1010633/ck_it_mobile_300x250_top'
            },
            ck_it_mobile_fplayer: {
                siteId: 3205799,
                networkId: 564,
                gpid: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_leadeboard: {
                siteId: 3205800,
                networkId: 564,
                gpid: '/1010633/ck_it_mobile_leadeboard'
            },
            cookist_it_inarticle: {
                siteId: 3205801,
                networkId: 564,
                gpid: '/1010633/cookist_it_inarticle'
            },
            geopop_top: {
                siteId: 3205802,
                networkId: 564,
                gpid: '/1010633/geopop_top'
            },
            geopop_middle: {
                siteId: 3205803,
                networkId: 564,
                gpid: '/1010633/geopop_middle'
            },
            geopop_fplayer: {
                siteId: 3205804,
                networkId: 564,
                gpid: '/1010633/geopop_fplayer'
            },
            geopop_leaderboard: {
                siteId: 3205805,
                networkId: 564,
                gpid: '/1010633/geopop_leaderboard'
            },
            geopop_bottom: {
                siteId: 3205806,
                networkId: 564,
                gpid: '/1010633/geopop_bottom'
            },
            geopop_inarticle: {
                siteId: 3205807,
                networkId: 564,
                gpid: '/1010633/geopop_inarticle'
            },
            kodami_top: {
                siteId: 3205808,
                networkId: 564,
                gpid: '/1010633/kodami_top'
            },
            kodami_middle: {
                siteId: 3205809,
                networkId: 564,
                gpid: '/1010633/kodami_middle'
            },
            kodami_low: {
                siteId: 3205810,
                networkId: 564,
                gpid: '/1010633/kodami_low'
            },
            kodami_header: {
                siteId: 3205811,
                networkId: 564,
                gpid: '/1010633/kodami_header'
            },
            kodami_bottom: {
                siteId: 3205812,
                networkId: 564,
                gpid: '/1010633/kodami_bottom'
            },
            ckmobile_300x250: {
                siteId: 3205813,
                networkId: 564,
                gpid: '/1010633/ckmobile_300x250'
            },
            ckmobile_300x250_top: {
                siteId: 3205814,
                networkId: 564,
                gpid: '/1010633/ckmobile_300x250_top'
            },
            ckmobile_300x250_bottom: {
                siteId: 3205815,
                networkId: 564,
                gpid: '/1010633/ckmobile_300x250_bottom'
            },
            ckmobile_fplayer: {
                siteId: 3205816,
                networkId: 564,
                gpid: '/1010633/ckmobile_fplayer'
            },
            ckmobile_leaderboard: {
                siteId: 3205817,
                networkId: 564,
                gpid: '/1010633/ckmobile_leaderboard'
            },
        }
    },
    rubicon: {
        display: {
            //inarticle
            fanpage_inarticle: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            cookist_it_inarticle: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724776,
            },
            geopop_inarticle: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            //  fanpage
            fpmobile_leadeboard: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            fpmobile_300x250_top: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            fpmobile_300x250: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            fpmobile_fplayer: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            fpmobile_300x250_bottom: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            //  cookstit
            ck_it_mobile_leadeboard: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724776,
            },
            ck_it_mobile_300x250_top: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724776,
            },
            ck_it_mobile_300x250: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724776,
            },
            ck_it_mobile_fplayer: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724776,
            },
            ck_it_mobile_fplayer2: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724776,
            },
            ck_it_mobile_fplayer3: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724776,
            },
            ck_it_mobile_fplayer4: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724776,
            },
            ck_it_mobile_300x250_bottom: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724776,
            },
            //  Ohga
            ohga_header: {
                accountId: 12546,
                siteId: 584384,
                zoneId: 3724802,
            },
            ohga_300x250_top: {
                accountId: 12546,
                siteId: 584384,
                zoneId: 3724802,
            },
            ohga_300x250_middle: {
                accountId: 12546,
                siteId: 584384,
                zoneId: 3724802,
            },
            ohga_low: {
                accountId: 12546,
                siteId: 584384,
                zoneId: 3724802,
            },
            ohga_bottom: {
                accountId: 12546,
                siteId: 584384,
                zoneId: 3724802,
            },
            //  Geopop
            geopop_leaderboard: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            geopop_top: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            geopop_middle: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            geopop_fplayer: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            geopop_fplayer2: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            geopop_fplayer3: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            geopop_fplayer4: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            geopop_bottom: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            //  cookistcom
            ckmobile_leaderboard: {
                accountId: 12546,
                siteId: 584386,
                zoneId: 3724794,
            },
            ckmobile_300x250_top: {
                accountId: 12546,
                siteId: 584386,
                zoneId: 3724794,
            },
            ckmobile_300x250: {
                accountId: 12546,
                siteId: 584386,
                zoneId: 3724794,
            },
            ckmobile_fplayer: {
                accountId: 12546,
                siteId: 584386,
                zoneId: 3724794,
            },
            ckmobile_300x250_bottom: {
                accountId: 12546,
                siteId: 584386,
                zoneId: 3724794,
            },
            //  Kodami
            //kodami_overlayer: {
            //    accountId: 12546,
            //    siteId: 583266,
            //    zoneId: 3724770,
            //},
            kodami_header: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            kodami_top: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            kodami_middle: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            kodami_low: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            kodami_bottom: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
        },
        video: {
            fanpage_video: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724772,
            },
            ck_it_video: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724778,
            },
            ck_wow_video: {
                accountId: 12546,
                siteId: 584386,
                zoneId: 3724796,
            },
            ck_legal_video: {
                accountId: 12546,
                siteId: 584386,
                zoneId: 3724796,
            },
            ohga_video: {
                accountId: 12546,
                siteId: 584384,
                zoneId: 3724804,
            },
            kodami_video: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724772,
            },
            geopop_video: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            wamily_video: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724772,
            },
            lexplain_video: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724772,
            },

        }
    },
    pubmatic_apex: {
        display: {
            //  fanpage
            fpmobile_leadeboard: {
                publisherId: '161546',
                adSlot: '6739111',
                gpid: '/1010633/fpmobile_leadeboard',
            },
            fpmobile_300x250_top: {
                publisherId: '161546',
                adSlot: '6739112',
                gpid: '/1010633/fpmobile_300x250_top',
            },
            fpmobile_300x250: {
                publisherId: '161546',
                adSlot: '6739113',
                gpid: '/1010633/fpmobile_300x250',
            },
            fpmobile_fplayer: {
                publisherId: '161546',
                adSlot: '6739114',
                gpid: '/1010633/fpmobile_fplayer',
            },
            fpmobile_300x250_bottom: {
                publisherId: '161546',
                adSlot: '6739115',
                gpid: '/1010633/fpmobile_300x250_bottom',
            },
            //  cookstit
            ck_it_mobile_leadeboard: {
                publisherId: '161546',
                adSlot: '6739116',
                gpid: '/1010633/ck_it_mobile_leadeboard',
            },
            ck_it_mobile_300x250_top: {
                publisherId: '161546',
                adSlot: '6739117',
                gpid: '/1010633/ck_it_mobile_300x250_top',
            },
            ck_it_mobile_300x250: {
                publisherId: '161546',
                adSlot: '6739118',
                gpid: '/1010633/ck_it_mobile_300x250',
            },
            ck_it_mobile_fplayer: {
                publisherId: '161546',
                adSlot: '6739119',
                gpid: '/1010633/ck_it_mobile_fplayer',
            },
            ck_it_mobile_fplayer2: {
                publisherId: '161546',
                adSlot: '6739120',
                gpid: '/1010633/ck_it_mobile_fplayer2',
            },
            ck_it_mobile_fplayer3: {
                publisherId: '161546',
                adSlot: '6739121',
                gpid: '/1010633/ck_it_mobile_fplayer3',
            },
            ck_it_mobile_fplayer4: {
                publisherId: '161546',
                adSlot: '6739122',
                gpid: '/1010633/ck_it_mobile_fplayer4',
            },
            ck_it_mobile_300x250_bottom: {
                publisherId: '161546',
                adSlot: '6739123',
                gpid: '/1010633/ck_it_mobile_300x250_bottom',
            },
            //  Ohga
            ohga_header: {
                publisherId: '161546',
                adSlot: '6739124',
                gpid: '/1010633/ohga_header',
            },
            ohga_300x250_top: {
                publisherId: '161546',
                adSlot: '6739125',
                gpid: '/1010633/ohga_300x250_top',
            },
            ohga_300x250_middle: {
                publisherId: '161546',
                adSlot: '6739126',
                gpid: '/1010633/ohga_300x250_middle',
            },
            ohga_low: {
                publisherId: '161546',
                adSlot: '6739127',
                gpid: '/1010633/ohga_low',
            },
            ohga_bottom: {
                publisherId: '161546',
                adSlot: '6739128',
                gpid: '/1010633/ohga_bottom',
            },
            //  Geopop
            geopop_leaderboard: {
                publisherId: '161546',
                adSlot: '6739129',
                gpid: '/1010633/geopop_leaderboard',
            },
            geopop_top: {
                publisherId: '161546',
                adSlot: '6739130',
                gpid: '/1010633/geopop_top',
            },
            geopop_middle: {
                publisherId: '161546',
                adSlot: '6739131',
                gpid: '/1010633/geopop_middle',
            },
            geopop_fplayer: {
                publisherId: '161546',
                adSlot: '6739132',
                gpid: '/1010633/geopop_fplayer',
            },

            geopop_fplayer2: {
                publisherId: '161546',
                adSlot: '6739133',
                gpid: '/1010633/geopop_fplayer/geopop_fplayer2',
            },

            geopop_fplayer3: {
                publisherId: '161546',
                adSlot: '6739134',
                gpid: '/1010633/geopop_fplayer/geopop_fplayer3',
            },

            geopop_fplayer4: {
                publisherId: '161546',
                adSlot: '6739135',
                gpid: '/1010633/geopop_fplayer/geopop_fplayer4',
            },
            geopop_bottom: {
                publisherId: '161546',
                adSlot: '6739136',
                gpid: '/1010633/geopop_bottom',
            },
            //  cookistcom
            ckmobile_leaderboard: {
                publisherId: '161546',
                adSlot: '6739137',
                gpid: '/1010633/ckmobile_leaderboard',
            },
            ckmobile_300x250_top: {
                publisherId: '161546',
                adSlot: '6739138',
                gpid: '/1010633/ckmobile_300x250_top',
            },
            ckmobile_300x250: {
                publisherId: '161546',
                adSlot: '6739139',
                gpid: '/1010633/ckmobile_300x250',
            },
            ckmobile_fplayer: {
                publisherId: '161546',
                adSlot: '6739140',
                gpid: '/1010633/ckmobile_fplayer',
            },
            ckmobile_300x250_bottom: {
                publisherId: '161546',
                adSlot: '6739141',
                gpid: '/1010633/ckmobile_300x250_bottom',
            },
            //  Kodami
            kodami_header: {
                publisherId: '161546',
                adSlot: '6739142',
                gpid: '/1010633/kodami_header',
            },
            kodami_top: {
                publisherId: '161546',
                adSlot: '6739143',
                gpid: '/1010633/kodami_top',
            },
            kodami_middle: {
                publisherId: '161546',
                adSlot: '6739144',
                gpid: '/1010633/kodami_middle',
            },
            kodami_low: {
                publisherId: '161546',
                adSlot: '6739145',
                gpid: '/1010633/kodami_low',
            },
            kodami_bottom: {
                publisherId: '161546',
                adSlot: '6739146    ',
                gpid: '/1010633/kodami_bottom',
            },
        },
        video: {
            fanpage_video: {
                publisherId: '161546',
                adSlot: '6739147',
                gpid: '/1010633/fanpage/video',
            },
            ck_it_video: {
                publisherId: '161546',
                adSlot: '6739150',
                gpid: '/1010633/cookistit/video',
            },
            ck_wow_video: {
                publisherId: '161546',
                adSlot: '6739158',
                gpid: '/1010633/cookistcom/video',
            },
            ck_legal_video: {
                publisherId: '161546',
                adSlot: '6739147',
                gpid: '/1010633/cookistlegal/video',
            },
            ohga_video: {
                publisherId: '161546',
                adSlot: '6739153',
                gpid: '/1010633/ohga/video',
            },
            kodami_video: {
                publisherId: '161546',
                adSlot: '6739161',
                gpid: '/1010633/kodami/video',
            },
            geopop_video: {
                publisherId: '161546',
                adSlot: '6739155',
                gpid: '/1010633/geopop/video',
            },
            wamily_video: {
                publisherId: '161546',
                adSlot: '6739147',
                gpid: '/1010633/wamily/video',
            },
            lexplain_video: {
                publisherId: '161546',
                adSlot: '6739147',
                gpid: '/1010633/lexplain/video',
            },

        }
    },
    criteo: {
        display: {
            //  Kodami
            kodami_header: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/kodami_header',
                pbadslot: '/1010633/kodami_header'
            },
            kodami_top: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/kodami_top',
                pbadslot: '/1010633/kodami_top'
            },
            kodami_middle: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/kodami_middle',
                pbadslot: '/1010633/kodami_middle'
            },
            kodami_low: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/kodami_low',
                pbadslot: '/1010633/kodami_low'
            },
            kodami_bottom: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/kodami_bottom',
                pbadslot: '/1010633/kodami_bottom'
            },
            //fanpage
            fpmobile_300x250: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/fpmobile_300x250',
                pbadslot: '/1010633/fpmobile_300x250'
            },
            fpmobile_300x250_top: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/fpmobile_300x250_top',
                pbadslot: '/1010633/fpmobile_300x250_top'
            },
            fpmobile_leadeboard: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/fpmobile_leadeboard',
                pbadslot: '/1010633/fpmobile_leadeboard'
            },
            fpmobile_fplayer: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/fpmobile_fplayer',
                pbadslot: '/1010633/fpmobile_fplayer'
            },
            fpmobile_300x250_bottom: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/fpmobile_300x250_bottom',
                pbadslot: '/1010633/fpmobile_300x250_bottom'
            },
            //cookistit
            ck_it_mobile_300x250: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ck_it_mobile_300x250',
                pbadslot: '/1010633/ck_it_mobile_300x250'
            },
            ck_it_mobile_300x250_top: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ck_it_mobile_300x250_top',
                pbadslot: '/1010633/ck_it_mobile_300x250_top'
            },
            ck_it_mobile_fplayer: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ck_it_mobile_fplayer',
                pbadslot: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_leadeboard: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ck_it_mobile_leadeboard',
                pbadslot: '/1010633/ck_it_mobile_leadeboard'
            },
            ck_it_mobile_fplayer2: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ck_it_mobile_fplayer',
                pbadslot: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_fplayer3: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ck_it_mobile_fplayer',
                pbadslot: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_fplayer4: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ck_it_mobile_fplayer',
                pbadslot: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_300x250_bottom: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ck_it_mobile_300x250_bottom',
                pbadslot: '/1010633/ck_it_mobile_300x250_bottom'
            },
            cookist_it_mobile_300x250: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/cookist_it_mobile_300x250',
                pbadslot: '/1010633/cookist_it_mobile_300x250'
            },
            cookist_it_mobile_300x250_bottom: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/cookist_it_mobile_300x250_bottom',
                pbadslot: '/1010633/cookist_it_mobile_300x250_bottom'
            },
            cookist_it_mobile_leaderboard: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ck_it_mobile_leadeboard',
                pbadslot: '/1010633/ck_it_mobile_leadeboard'
            },
            //geopop
            geopop_leaderboard: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/geopop_leaderboard',
                pbadslot: '/1010633/geopop_leaderboard'
            },
            geopop_middle: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/geopop_middle',
                pbadslot: '/1010633/geopop_middle'
            },
            geopop_top: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/geopop_top',
                pbadslot: '/1010633/geopop_top'
            },
            geopop_fplayer: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/geopop_fplayer',
                pbadslot: '/1010633/geopop_fplayer'
            },
            geopop_fplayer2: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/geopop_fplayer/geopop_fplayer2',
                pbadslot: '/1010633/geopop_fplayer/geopop_fplayer2'
            },
            geopop_fplayer3: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/geopop_fplayer/geopop_fplayer3',
                pbadslot: '/1010633/geopop_fplayer/geopop_fplayer3'
            },
            geopop_fplayer4: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/geopop_fplayer/geopop_fplayer4',
                pbadslot: '/1010633/geopop_fplayer/geopop_fplayer4'
            },
            geopop_bottom: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/geopop_bottom',
                pbadslot: '/1010633/geopop_bottom'
            },
            //cookistcom
            ckmobile_300x250: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ckmobile_300x250',
                pbadslot: '/1010633/ckmobile_300x250'
            },
            ckmobile_300x250_bottom: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ckmobile_300x250_bottom',
                pbadslot: '/1010633/ckmobile_300x250_bottom'
            },
            ckmobile_300x250_top: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ckmobile_300x250_top',
                pbadslot: '/1010633/ckmobile_300x250_top'
            },
            ckmobile_fplayer: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ckmobile_fplayer',
                pbadslot: '/1010633/ckmobile_fplayer'
            },
        },
        video: {
            fanpage_video: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/fanpage/video',
                pbadslot: '/1010633/fanpage/video'
            },
            ck_it_video: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/cookistit/video',
                pbadslot: '/1010633/cookistit/video'
            },
            ck_wow_video: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/cookistcom/video',
                pbadslot: '/1010633/cookistcom/video'
            },
            ck_legal_video: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/cookistlegal/video',
                pbadslot: '/1010633/cookistlegal/video'
            },
            ohga_video: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ohga/video',
                pbadslot: '/1010633/ohga/video'
            },
            kodami_video: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/kodami/video',
                pbadslot: '/1010633/kodami/video'
            },
            geopop_video: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/geopop/video',
                pbadslot: '/1010633/geopop/video'
            },
            wamily_video: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/wamily/video',
                pbadslot: '/1010633/wamily/video'
            },
            lexplain_video: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/lexplain/video',
                pbadslot: '/1010633/lexplain/video'
            },
        }
    },
    ix: {
        display: {
            //  Kodami
            go_interstitial: {
                siteId: '1332238',
                gpid: '/1010633/go_interstitial',
            },
            kodami_header: {
                siteId: '1195764',
                gpid: '/1010633/kodami_header' //tu che leggi ti chiederai "a che cazz serv?": serve.
            },
            kodami_top: {
                siteId: '1195765',
                gpid: '/1010633/kodami_top'
            },
            kodami_middle: {
                siteId: '1195763',
                gpid: '/1010633/kodami_middle'
            },
            kodami_low: {
                siteId: '1195762',
                gpid: '/1010633/kodami_low'
            },
            kodami_bottom: {
                siteId: '1195766',
                gpid: '/1010633/kodami_bottom'
            },
            //fanpage
            fpmobile_300x250: {
                siteId: '1195740',
                gpid: '/1010633/fpmobile_300x250'
            },
            fpmobile_300x250_top: {
                siteId: '1195745',
                gpid: '/1010633/fpmobile_300x250_top'
            },
            fpmobile_leadeboard: {
                siteId: '1195739',
                gpid: '/1010633/fpmobile_leadeboard'
            },
            fpmobile_fplayer: {
                siteId: '1195744',
                gpid: '/1010633/fpmobile_fplayer'
            },
            fpmobile_300x250_bottom: {
                siteId: '1195743',
                gpid: '/1010633/fpmobile_300x250_bottom'
            },
            //cookistit
            ck_it_mobile_300x250: {
                siteId: '1195754',
                gpid: '/1010633/ck_it_mobile_300x250'
            },
            ck_it_mobile_300x250_top: {
                siteId: '1195758',
                gpid: '/1010633/ck_it_mobile_300x250_top'
            },
            ck_it_mobile_fplayer: {
                siteId: '1195755',
                gpid: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_leadeboard: {
                siteId: '1195757',
                gpid: '/1010633/ck_it_mobile_leadeboard'
            },
            ck_it_mobile_fplayer2: {
                siteId: '1195755',
                gpid: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_fplayer3: {
                siteId: '1195755',
                gpid: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_fplayer4: {
                siteId: '1195755',
                gpid: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_300x250_bottom: {
                siteId: '1195756',
                gpid: '/1010633/ck_it_mobile_300x250_bottom'
            },
            cookist_it_mobile_300x250: {
                siteId: '1195754',
                gpid: '/1010633/cookist_it_mobile_300x250'
            },
            cookist_it_mobile_300x250_bottom: {
                siteId: '1195756',
                gpid: '/1010633/cookist_it_mobile_300x250_bottom'
            },
            cookist_it_mobile_leaderboard: {
                siteId: '1195757',
                gpid: '/1010633/ck_it_mobile_leadeboard'
            },
            //geopop
            geopop_leaderboard: {
                siteId: '1195773',
                gpid: '/1010633/geopop_leaderboard'
            },
            geopop_middle: {
                siteId: '1195771',
                gpid: '/1010633/geopop_middle'
            },
            geopop_top: {
                siteId: '1195770',
                gpid: '/1010633/geopop_top'
            },
            geopop_fplayer: {
                siteId: '1195774',
                gpid: '/1010633/geopop_fplayer'
            },
            geopop_fplayer2: {
                siteId: '1195774',
                gpid: '/1010633/geopop_fplayer/geopop_fplayer2'
            },
            geopop_fplayer3: {
                siteId: '1195774',
                gpid: '/1010633/geopop_fplayer/geopop_fplayer3'
            },
            geopop_fplayer4: {
                siteId: '1195774',
                gpid: '/1010633/geopop_fplayer/geopop_fplayer4'
            },
            geopop_bottom: {
                siteId: '1195769',
                gpid: '/1010633/geopop_bottom'
            },
            //cookistcom
            ckmobile_300x250: {
                siteId: '1195754',
                gpid: '/1010633/ckmobile_300x250'
            },
            ckmobile_300x250_bottom: {
                siteId: '1195756',
                gpid: '/1010633/ckmobile_300x250_bottom'
            },
            ckmobile_300x250_top: {
                siteId: '1195758',
                gpid: '/1010633/ckmobile_300x250_top'
            },
            ckmobile_fplayer: {
                siteId: '1195755',
                gpid: '/1010633/ckmobile_fplayer'
            },
        },
        video: {
            fanpage_video: {
                siteId: '1195741',
                gpid: '/1010633/fanpage/video'
            },
            ck_it_video: {
                siteId: '1195759',
                gpid: '/1010633/cookistit/video'
            },
            ck_wow_video: {
                siteId: '1195748',
                gpid: '/1010633/cookistcom/video'
            },
            ck_legal_video: {
                siteId: '1195748',
                gpid: '/1010633/cookistlegal/video'
            },
            ohga_video: {
                siteId: '1195741',
                gpid: '/1010633/ohga/video'
            },
            kodami_video: {
                siteId: '1195767',
                gpid: '/1010633/kodami/video'
            },
            geopop_video: {
                siteId: '1195775',
                gpid: '/1010633/geopop/video'
            },
            wamily_video: {
                siteId: '1195767',
                gpid: '/1010633/wamily/video'
            },
            lexplain_video: {
                siteId: '1195767',
                gpid: '/1010633/lexplain/video'
            },
        }
    },
    ogury: {
        display: {
            // fanpage.it
            fpmobile_300x250: {
                assetKey: 'OGY-BCCBF11AEA48',
                adUnitId: 'wm-hb-stdb-fanpag-ciaop-4bcaceqv7bxi',
                gpid: '/1010633/fpmobile_300x250'
            },
            fpmobile_300x250_bottom: {
                assetKey: 'OGY-BCCBF11AEA48',
                //adUnitId: 'wm-hb-stdb-fanpag-ciaop-t5ibzbmq389q',
                adUnitId: 'wm-hb-iart-fanpag-ciaop-4jkgmplmztwy',
                gpid: '/1010633/pmobile_300x250_bottom'
            },
            fpmobile_fplayer: {
                assetKey: 'OGY-BCCBF11AEA48',
                adUnitId: 'wm-hb-stdb-fanpag-ciaop-0xtdyl2zjz9g',
                gpid: '/1010633/fpmobile_fplayer'
            },
            fpmobile_300x250_top: {
                assetKey: 'OGY-BCCBF11AEA48',
                adUnitId: 'wm-hb-stdb-fanpag-ciaop-a71zr0db0uv0',
                gpid: '/1010633/fpmobile_300x250_top'
            },
            fpmobile_leaderboard: {
                assetKey: 'OGY-BCCBF11AEA48',
                adUnitId: 'wm-hb-stdb-fanpag-ciaop-zrk8qi6lnmsv',
                gpid: '/1010633/fpmobile_leaderboard'
            },
            fanpage_inarticle: {
                assetKey: 'OGY-BCCBF11AEA48',
                adUnitId: 'wm-hb-stdb-fanpag-ciaop-7huxp6v4jfed',
                gpid: '/1010633/fanpage_inarticle'
            },

            // cookist.it
            ck_it_mobile_300x250: {
                assetKey: 'OGY-90CD324234B1',
                adUnitId: 'wm-hb-stdb-cookis-ciaop-jpw2ihcsalhx',
                gpid: '/1010633/ck_it_mobile_300x250'
            },
            ck_it_mobile_300x250_bottom: {
                assetKey: 'OGY-90CD324234B1',
                //adUnitId: 'wm-hb-stdb-cookis-ciaop-sysijvgw0uft',
                adUnitid: 'wm-hb-iart-cookis-ciaop-bm7mpunewr0y',
                gpid: '/1010633/ck_it_mobile_300x250_bottom'
            },
            ck_it_mobile_300x250_top: {
                assetKey: 'OGY-90CD324234B1',
                adUnitId: 'wm-hb-stdb-cookis-ciaop-vteoyitzpdos',
                gpid: '/1010633/ck_it_mobile_300x250_top'
            },
            ck_it_mobile_fplayer: {
                assetKey: 'OGY-90CD324234B1',
                adUnitId: 'wm-hb-stdb-cookis-ciaop-24ileikwtkii',
                gpid: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_leadeboard: {
                assetKey: 'OGY-90CD324234B1',
                adUnitId: 'wm-hb-stdb-cookis-ciaop-21qvhwpfvldr',
                gpid: '/1010633/ck_it_mobile_leadeboard'
            },
            cookist_it_inarticle: {
                assetKey: 'OGY-90CD324234B1',
                adUnitId: 'wm-hb-stdb-cookis-ciaop-bpcq6xfzhbn8',
                gpid: '/1010633/cookist_it_inarticle'
            },

            // ohga.it
            ohga_300x250_middle: {
                assetKey: 'OGY-80DDD5B1EE4A',
                adUnitId: 'wm-hb-stdb-ohga-ciaop-hd5nz9k2qecbuw',
                gpid: '/1010633/ohga_300x250_middle'
            },
            ohga_300x250_top: {
                assetKey: 'OGY-80DDD5B1EE4A',
                adUnitId: 'wm-hb-stdb-ohga-ciaop-gbj3ko0sxtbxmx',
                gpid: '/1010633/ohga_300x250_top'
            },
            ohga_bottom: {
                assetKey: 'OGY-80DDD5B1EE4A',
                //adUnitId: 'wm-hb-stdb-ohga-ciaop-v1k4faqxaohlay',
                adUnitId: 'wm-hb-iart-ohga-ciaop-mf8jmjykbdaofh',
                gpid: '/1010633/ohga_bottom'
            },
            ohga_header: {
                assetKey: 'OGY-80DDD5B1EE4A',
                adUnitId: 'wm-hb-stdb-ohga-ciaop-ijgzhfuq0wzlbu',
                gpid: '/1010633/ohga_header'
            },
            // cookistcom
            ckmobile_leaderboard: {
                assetKey: 'OGY-E2E75C934F08',
                adUnitId: 'wm-hb-stdb-cookis-ciaop-q32jbs8vybun',
                gpid: '/1010633/ckmobile_leaderboard'
            },
            ckmobile_300x250: {
                assetKey: 'OGY-E2E75C934F08',
                adUnitId: 'wm-hb-stdb-cookis-ciaop-szncsuqfvqrq',
                gpid: '/1010633/ckmobile_300x250'
            },
            ckmobile_300x250_bottom: {
                assetKey: 'OGY-E2E75C934F08',
                //adUnitId: 'wm-hb-stdb-cookis-ciaop-atdd9vdgkl1w',
                adUnitId: 'wm-hb-iart-cookis-ciaop-edef7kkiskjj',
                gpid: '/1010633/ckmobile_300x250_bottom'
            },
            ckmobile_300x250_top: {
                assetKey: 'OGY-E2E75C934F08',
                adUnitId: 'wm-hb-stdb-cookis-ciaop-gk7bia1sqjk9',
                gpid: '/1010633/ckmobile_300x250_top'
            },
            ckmobile_fplayer: {
                assetKey: 'OGY-E2E75C934F08',
                adUnitId: 'wm-hb-stdb-cookis-ciaop-cwpbeyhmfapz',
                gpid: '/1010633/ckmobile_fplayer'
            },
            // geopop.it
            geopop_top: {
                assetKey: 'OGY-525961E33587',
                adUnitId: 'wm-hb-stdb-geopop-ciaop-qo2gikzxzevt',
                gpid: '/1010633/geopop_top'
            },
            geopop_middle: {
                assetKey: 'OGY-525961E33587',
                adUnitId: 'wm-hb-stdb-geopop-ciaop-h3v8liv6sle4',
                gpid: '/1010633/geopop_middle'
            },
            geopop_bottom: {
                assetKey: 'OGY-525961E33587',
                //adUnitId: 'wm-hb-stdb-geopop-ciaop-basiodus6zqn',
                adUnitId: 'wm-hb-iart-geopop-ciaop-nczdlanq6iao',
                gpid: '/1010633/geopop_bottom'
            },
            geopop_leaderboard: {
                assetKey: 'OGY-525961E33587',
                adUnitId: 'wm-hb-stdb-geopop-ciaop-6byvhmrraqdp',
                gpid: '/1010633/geopop_leaderboard'
            },
            geopop_fplayer: {
                assetKey: 'OGY-525961E33587',
                adUnitId: 'wm-hb-stdb-geopop-ciaop-memyjv7yc6a0',
                gpid: '/1010633/geopop_fplayer'
            },
            geopop_inarticle: {
                assetKey: 'OGY-525961E33587',
                adUnitId: 'wm-hb-stdb-geopop-ciaop-m8jvmwghurq1',
                gpid: '/1010633/geopop_inarticle'
            }
        },
    },
    seedtag: {
        display: {
            go_interstitial: {
                publisherId: '1044-6008-01',
                adUnitId: '37209542',
                placement: 'inTerstitial',
                gpid: '/1010633/go_interstitial',
            },
            // Kodami
            kodami_header: {
                publisherId: '8274-3016-01',
                adUnitId: '35406507',
                placement: 'inBanner',
                gpid: '/1010633/kodami_header'
            },
            kodami_top: {
                publisherId: '8274-3016-01',
                adUnitId: '35406643',
                placement: 'inArticle',
                gpid: '/1010633/kodami_top'
            },
            kodami_middle: {
                publisherId: '8274-3016-01',
                adUnitId: '35406642',
                placement: 'inArticle',
                gpid: '/1010633/kodami_middle'
            },
            kodami_low: {
                publisherId: '8274-3016-01',
                adUnitId: '35406641',
                placement: 'inArticle',
                gpid: '/1010633/kodami_low'
            },
            kodami_bottom: {
                publisherId: '8274-3016-01',
                adUnitId: '35406506',
                placement: 'inArticle',
                gpid: '/1010633/kodami_bottom'
            },
            // fanpage
            fpmobile_300x250: {
                publisherId: '1044-6008-01',
                adUnitId: '35406650',
                placement: 'inArticle',
                gpid: '/1010633/fpmobile_300x250'
            },
            fpmobile_300x250_top: {
                publisherId: '1044-6008-01',
                adUnitId: '36570985',
                placement: 'inBanner',
                gpid: '/1010633/fpmobile_300x250_top'
            },
            fpmobile_leadeboard: {
                publisherId: '1044-6008-01',
                adUnitId: '35406441',
                placement: 'inBanner',
                gpid: '/1010633/fpmobile_leadeboard'
            },
            fpmobile_fplayer: {
                publisherId: '1044-6008-01',
                adUnitId: '35406652',
                placement: 'inBanner',
                gpid: '/1010633/fpmobile_fplayer'
            },
            fpmobile_300x250_bottom: {
                publisherId: '1044-6008-01',
                adUnitId: '35406440',
                placement: 'inBanner',
                gpid: '/1010633/fpmobile_300x250_bottom'
            },
            // cookistit
            ck_it_mobile_300x250: {
                publisherId: '3396-5388-01',
                adUnitId: '35406635',
                placement: 'inArticle',
                gpid: '/1010633/ck_it_mobile_300x250'
            },
            ck_it_mobile_300x250_top: {
                publisherId: '3396-5388-01',
                adUnitId: '35406636',
                placement: 'inBanner',
                gpid: '/1010633/ck_it_mobile_300x250_top'
            },
            ck_it_mobile_fplayer: {
                publisherId: '3396-5388-01',
                adUnitId: '35406637',
                placement: 'inBanner',
                gpid: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_leadeboard: {
                publisherId: '3396-5388-01',
                adUnitId: '35406470',
                placement: 'inBanner',
                gpid: '/1010633/ck_it_mobile_leadeboard'
            },
            ck_it_mobile_fplayer2: {
                publisherId: '3396-5388-01',
                adUnitId: '35406470',
                placement: 'inBanner',
                gpid: '/1010633/ck_it_mobile_fplayer2'
            },
            ck_it_mobile_fplayer3: {
                publisherId: '3396-5388-01',
                adUnitId: '35406470',
                placement: 'inBanner',
                gpid: '/1010633/ck_it_mobile_fplayer3'
            },
            ck_it_mobile_fplayer4: {
                publisherId: '3396-5388-01',
                adUnitId: '35406470',
                placement: 'inBanner',
                gpid: '/1010633/ck_it_mobile_fplayer4'
            },
            ck_it_mobile_300x250_bottom: {
                publisherId: '3396-5388-01',
                adUnitId: '35406469',
                placement: 'inBanner',
                gpid: '/1010633/ck_it_mobile_300x250_bottom'
            },
            cookist_it_mobile_300x250: {
                publisherId: '3396-5388-01',
                adUnitId: '35406635',
                placement: 'inArticle',
                gpid: '/1010633/cookist_it_mobile_300x250'
            },
            cookist_it_mobile_300x250_bottom: {
                publisherId: '3396-5388-01',
                adUnitId: '35406469',
                placement: 'inBanner',
                gpid: '/1010633/cookist_it_mobile_300x250_bottom'
            },
            cookist_it_mobile_leaderboard: {
                publisherId: '3396-5388-01',
                adUnitId: '35406470',
                placement: 'inBanner',
                gpid: '/1010633/cookist_it_mobile_leaderboard'
            },
            // geopop
            geopop_leaderboard: {
                publisherId: '2008-0806-01',
                adUnitId: '35406645',
                placement: 'inBanner',
                gpid: '/1010633/geopop_leaderboard'
            },
            geopop_middle: {
                publisherId: '2008-0806-01',
                adUnitId: '35406647',
                placement: 'inBanner',
                gpid: '/1010633/geopop_middle'
            },
            geopop_top: {
                publisherId: '2008-0806-01',
                adUnitId: '35406648',
                placement: 'inBanner',
                gpid: '/1010633/geopop_top'
            },
            geopop_fplayer: {
                publisherId: '2008-0806-01',
                adUnitId: '35406646',
                placement: 'inArticle',
                gpid: '/1010633/geopop_fplayer'
            },
            geopop_fplayer2: {
                publisherId: '2008-0806-01',
                adUnitId: '35406646',
                placement: 'inArticle',
                gpid: '/1010633/geopop_fplayer2'
            },
            geopop_fplayer3: {
                publisherId: '2008-0806-01',
                adUnitId: '35406646',
                placement: 'inArticle',
                gpid: '/1010633/geopop_fplayer3'
            },
            geopop_fplayer4: {
                publisherId: '2008-0806-01',
                adUnitId: '35406646',
                placement: 'inArticle',
                gpid: '/1010633/geopop_fplayer4'
            },
            geopop_bottom: {
                publisherId: '2008-0806-01',
                adUnitId: '35406644',
                placement: 'inBanner',
                gpid: '/1010633/geopop_bottom'
            },
            // cookistcom
            ckmobile_300x250: {
                publisherId: '4258-6544-01',
                adUnitId: '35406626',
                placement: 'inArticle',
                gpid: '/1010633/ckmobile_300x250'
            },
            ckmobile_300x250_bottom: {
                publisherId: '4258-6544-01',
                adUnitId: '35406630',
                placement: 'inBanner',
                gpid: '/1010633/ckmobile_300x250_bottom'
            },
            ckmobile_300x250_top: {
                publisherId: '4258-6544-01',
                adUnitId: '35406628',
                placement: 'inArticle',
                gpid: '/1010633/ckmobile_300x250_top'
            },
            ckmobile_fplayer: {
                publisherId: '4258-6544-01',
                adUnitId: '35406629',
                placement: 'inArticle',
                gpid: '/1010633/ckmobile_fplayer'
            },
        },
        video: {
            fanpage_video: {
                publisherId: '1044-6008-01',
                adUnitId: '35406438',
                placement: 'inStream',
                gpid: '/1010633/fanpage_video'
            },
            ck_it_video: {
                publisherId: '3396-5388-01',
                adUnitId: '35406608',
                placement: 'inStream',
                gpid: '/1010633/ck_it_video'
            },
            ck_wow_video: {
                publisherId: '4258-6544-01',
                adUnitId: '35406601',
                placement: 'inStream',
                gpid: '/1010633/ck_wow_video'
            },
            ck_legal_video: {
                publisherId: '4258-6544-01',
                adUnitId: '35406601',
                placement: 'inStream',
                gpid: '/1010633/ck_legal_video'
            },
            ohga_video: {
                publisherId: '1044-6008-01',
                adUnitId: '35406438',
                placement: 'inStream',
                gpid: '/1010633/ohga_video'
            },
            kodami_video: {
                publisherId: '8274-3016-01',
                adUnitId: '35406527',
                placement: 'inStream',
                gpid: '/1010633/kodami_video'
            },
            geopop_video: {
                publisherId: '2008-0806-01',
                adUnitId: '35406523',
                placement: 'inStream',
                gpid: '/1010633/geopop_video'
            },
            wamily_video: {
                publisherId: '1044-6008-01',
                adUnitId: '35406438',
                placement: 'inStream',
                gpid: '/1010633/wamily_video'
            },
            lexplain_video: {
                publisherId: '1044-6008-01',
                adUnitId: '35406438',
                placement: 'inStream',
                gpid: '/1010633/lexplain_video'
            }
        }
    },
    pubmatic: {
        display: {
            //  inarticle
            fanpage_inarticle: {
                publisherId: '161182',
                adSlot: '6787215',
                gpid: '/1010633/fanpage_inarticle',
            },
            cookist_it_inarticle: {
                publisherId: '161182',
                adSlot: '6787250',
                gpid: '/1010633/cookist_it_inarticle',
            },
            geopop_inarticle: {
                publisherId: '161182',
                adSlot: '6787275',
                gpid: '/1010633/geopop_inarticle',
            },
            //  fanpage
            fpmobile_leadeboard: {
                publisherId: '161182',
                adSlot: '6629965',
                gpid: '/1010633/fpmobile_leadeboard',
            },
            fpmobile_300x250_top: {
                publisherId: '161182',
                adSlot: '6629966',
                gpid: '/1010633/fpmobile_300x250_top',
            },
            fpmobile_300x250: {
                publisherId: '161182',
                adSlot: '6629967',
                gpid: '/1010633/fpmobile_300x250',
            },
            fpmobile_fplayer: {
                publisherId: '161182',
                adSlot: '6629968',
                gpid: '/1010633/fpmobile_fplayer',
            },
            fpmobile_300x250_bottom: {
                publisherId: '161182',
                adSlot: '6629969',
                gpid: '/1010633/fpmobile_300x250_bottom',
            },
            //  cookstit
            ck_it_mobile_leadeboard: {
                publisherId: '161182',
                adSlot: '6629970',
                gpid: '/1010633/ck_it_mobile_leadeboard',
            },
            ck_it_mobile_300x250_top: {
                publisherId: '161182',
                adSlot: '6629971',
                gpid: '/1010633/ck_it_mobile_300x250_top',
            },
            ck_it_mobile_300x250: {
                publisherId: '161182',
                adSlot: '6629972',
                gpid: '/1010633/ck_it_mobile_300x250',
            },
            ck_it_mobile_fplayer: {
                publisherId: '161182',
                adSlot: '6629973',
                gpid: '/1010633/ck_it_mobile_fplayer',
            },
            ck_it_mobile_fplayer2: {
                publisherId: '161182',
                adSlot: '6629974',
                gpid: '/1010633/ck_it_mobile_fplayer2',
            },
            ck_it_mobile_fplayer3: {
                publisherId: '161182',
                adSlot: '6629975',
                gpid: '/1010633/ck_it_mobile_fplayer3',
            },
            ck_it_mobile_fplayer4: {
                publisherId: '161182',
                adSlot: '6629976',
                gpid: '/1010633/ck_it_mobile_fplayer4',
            },
            ck_it_mobile_300x250_bottom: {
                publisherId: '161182',
                adSlot: '6629977',
                gpid: '/1010633/ck_it_mobile_300x250_bottom',
            },
            //  Ohga
            ohga_header: {
                publisherId: '161182',
                adSlot: '6629978',
                gpid: '/1010633/ohga_header',
            },
            ohga_300x250_top: {
                publisherId: '161182',
                adSlot: '6629979',
                gpid: '/1010633/ohga_300x250_top',
            },
            ohga_300x250_middle: {
                publisherId: '161182',
                adSlot: '6629980',
                gpid: '/1010633/ohga_300x250_middle',
            },
            ohga_low: {
                publisherId: '161182',
                adSlot: '6629981',
                gpid: '/1010633/ohga_low',
            },
            ohga_bottom: {
                publisherId: '161182',
                adSlot: '6629982',
                gpid: '/1010633/ohga_bottom',
            },
            //  Geopop
            geopop_leaderboard: {
                publisherId: '161182',
                adSlot: '6629983',
                gpid: '/1010633/geopop_leaderboard',
            },
            geopop_top: {
                publisherId: '161182',
                adSlot: '6629984',
                gpid: '/1010633/geopop_top',
            },
            geopop_middle: {
                publisherId: '161182',
                adSlot: '6629985',
                gpid: '/1010633/geopop_middle',
            },
            geopop_fplayer: {
                publisherId: '161182',
                adSlot: '6629986',
                gpid: '/1010633/geopop_fplayer',
            },

            geopop_fplayer2: {
                publisherId: '161182',
                adSlot: '6629987',
                gpid: '/1010633/geopop_fplayer/geopop_fplayer2',
            },

            geopop_fplayer3: {
                publisherId: '161182',
                adSlot: '6629988',
                gpid: '/1010633/geopop_fplayer/geopop_fplayer3',
            },

            geopop_fplayer4: {
                publisherId: '161182',
                adSlot: '6629989',
                gpid: '/1010633/geopop_fplayer/geopop_fplayer4',
            },
            geopop_bottom: {
                publisherId: '161182',
                adSlot: '6629990',
                gpid: '/1010633/geopop_bottom',
            },
            //  cookistcom
            ckmobile_leaderboard: {
                publisherId: '161182',
                adSlot: '6629991',
                gpid: '/1010633/ckmobile_leaderboard',
            },
            ckmobile_300x250_top: {
                publisherId: '161182',
                adSlot: '6629992',
                gpid: '/1010633/ckmobile_300x250_top',
            },
            ckmobile_300x250: {
                publisherId: '161182',
                adSlot: '6629993',
                gpid: '/1010633/ckmobile_300x250',
            },
            ckmobile_fplayer: {
                publisherId: '161182',
                adSlot: '6629994',
                gpid: '/1010633/ckmobile_fplayer',
            },
            ckmobile_300x250_bottom: {
                publisherId: '161182',
                adSlot: '6629995',
                gpid: '/1010633/ckmobile_300x250_bottom',
            },
            //  Kodami
            kodami_header: {
                publisherId: '161182',
                adSlot: '6629996',
                gpid: '/1010633/kodami_header',
            },
            kodami_top: {
                publisherId: '161182',
                adSlot: '6629997',
                gpid: '/1010633/kodami_top',
            },
            kodami_middle: {
                publisherId: '161182',
                adSlot: '6629998',
                gpid: '/1010633/kodami_middle',
            },
            kodami_low: {
                publisherId: '161182',
                adSlot: '6629999',
                gpid: '/1010633/kodami_low',
            },
            kodami_bottom: {
                publisherId: '161182',
                adSlot: '6630000',
                gpid: '/1010633/kodami_bottom',
            },
        },
        video: {
            fanpage_video: {
                publisherId: '161182',
                adSlot: '6790502',
                gpid: '/1010633/fanpage/video',
            },
            ck_it_video: {
                publisherId: '161182',
                adSlot: '6790505',
                gpid: '/1010633/cookistit/video',
            },
            ck_wow_video: {
                publisherId: '161182',
                adSlot: '6790513',
                gpid: '/1010633/cookistcom/video',
            },
            ck_legal_video: {
                publisherId: '161182',
                adSlot: '6790513',
                gpid: '/1010633/cookistlegal/video',
            },
            ohga_video: {
                publisherId: '161182',
                adSlot: '6790508',
                gpid: '/1010633/ohga/video',
            },
            kodami_video: {
                publisherId: '161182',
                adSlot: '6790516',
                gpid: '/1010633/kodami/video',
            },
            geopop_video: {
                publisherId: '161182',
                adSlot: '6790510',
                gpid: '/1010633/geopop/video',
            },
            wamily_video: {
                publisherId: '161182',
                adSlot: '6790502',
                gpid: '/1010633/wamily/video',
            },
            lexplain_video: {
                publisherId: '161182',
                adSlot: '6790502',
                gpid: '/1010633/lexplain/video',
            },

        }
    },
    ozone: {
        display: {
            fanpage_inarticle: { publisherId: 'OZONECIA0001', siteId: '1500000956', placementId: '3500024011', gpid: '/1010633/fanpage_inarticle' },
            cookist_it_inarticle: { publisherId: 'OZONECIA0001', siteId: '1500000957', placementId: '3500024020', gpid: '/1010633/cookist_it_inarticle' },
            geopop_inarticle: { publisherId: 'OZONECIA0001', siteId: '1500000958', placementId: '3500024029', gpid: '/1010633/geopop_inarticle' },
            //  fanpage
            fpmobile_leadeboard: { publisherId: 'OZONECIA0001', siteId: '1500000956', placementId: '3500024010', gpid: '/1010633/fpmobile_leadeboard' },
            fpmobile_300x250_top: { publisherId: 'OZONECIA0001', siteId: '1500000956', placementId: '3500024009', gpid: '/1010633/fpmobile_300x250_top' },
            fpmobile_300x250: { publisherId: 'OZONECIA0001', siteId: '1500000956', placementId: '3500024006', gpid: '/1010633/fpmobile_300x250' },
            fpmobile_fplayer: { publisherId: 'OZONECIA0001', siteId: '1500000956', placementId: '3500024008', gpid: '/1010633/fpmobile_fplayer' },
            fpmobile_300x250_bottom: { publisherId: 'OZONECIA0001', siteId: '1500000956', placementId: '3500024007', gpid: '/1010633/fpmobile_300x250_bottom' },
            //  cookistit
            ck_it_mobile_leadeboard: { publisherId: 'OZONECIA0001', siteId: '1500000957', placementId: '3500024019', gpid: '/1010633/ck_it_mobile_leadeboard' },
            ck_it_mobile_300x250_top: { publisherId: 'OZONECIA0001', siteId: '1500000957', placementId: '3500024017', gpid: '/1010633/ck_it_mobile_300x250_top' },
            ck_it_mobile_300x250: { publisherId: 'OZONECIA0001', siteId: '1500000957', placementId: '3500024015', gpid: '/1010633/ck_it_mobile_300x250' },
            ck_it_mobile_fplayer: { publisherId: 'OZONECIA0001', siteId: '1500000957', placementId: '3500024018', gpid: '/1010633/ck_it_mobile_fplayer' },
            ck_it_mobile_fplayer2: { publisherId: 'OZONECIA0001', siteId: '1500000957', placementId: '3500024018', gpid: '/1010633/ck_it_mobile_fplayer2' },
            ck_it_mobile_fplayer3: { publisherId: 'OZONECIA0001', siteId: '1500000957', placementId: '3500024018', gpid: '/1010633/ck_it_mobile_fplayer3' },
            ck_it_mobile_fplayer4: { publisherId: 'OZONECIA0001', siteId: '1500000957', placementId: '3500024018', gpid: '/1010633/ck_it_mobile_fplayer4' },
            ck_it_mobile_300x250_bottom: { publisherId: 'OZONECIA0001', siteId: '1500000957', placementId: '3500024016', gpid: '/1010633/ck_it_mobile_300x250_bottom' },
            //  Ohga (non fornito da Ozone)
            ohga_header: { publisherId: '', siteId: '', placementId: '', gpid: '/1010633/ohga_header' },
            ohga_300x250_top: { publisherId: '', siteId: '', placementId: '', gpid: '/1010633/ohga_300x250_top' },
            ohga_300x250_middle: { publisherId: '', siteId: '', placementId: '', gpid: '/1010633/ohga_300x250_middle' },
            ohga_low: { publisherId: '', siteId: '', placementId: '', gpid: '/1010633/ohga_low' },
            ohga_bottom: { publisherId: '', siteId: '', placementId: '', gpid: '/1010633/ohga_bottom' },
            //  Geopop
            geopop_leaderboard: { publisherId: 'OZONECIA0001', siteId: '1500000958', placementId: '3500024027', gpid: '/1010633/geopop_leaderboard' },
            geopop_top: { publisherId: 'OZONECIA0001', siteId: '1500000958', placementId: '3500024024', gpid: '/1010633/geopop_top' },
            geopop_middle: { publisherId: 'OZONECIA0001', siteId: '1500000958', placementId: '3500024025', gpid: '/1010633/geopop_middle' },
            geopop_fplayer: { publisherId: 'OZONECIA0001', siteId: '1500000958', placementId: '3500024026', gpid: '/1010633/geopop_fplayer' },
            geopop_fplayer2: { publisherId: 'OZONECIA0001', siteId: '1500000958', placementId: '3500024026', gpid: '/1010633/geopop_fplayer/geopop_fplayer2' },
            geopop_fplayer3: { publisherId: 'OZONECIA0001', siteId: '1500000958', placementId: '3500024026', gpid: '/1010633/geopop_fplayer/geopop_fplayer3' },
            geopop_fplayer4: { publisherId: 'OZONECIA0001', siteId: '1500000958', placementId: '3500024026', gpid: '/1010633/geopop_fplayer/geopop_fplayer4' },
            geopop_bottom: { publisherId: 'OZONECIA0001', siteId: '1500000958', placementId: '3500024028', gpid: '/1010633/geopop_bottom' },
            //  cookistcom
            ckmobile_leaderboard: { publisherId: 'OZONECIA0001', siteId: '1500000960', placementId: '3500024046', gpid: '/1010633/ckmobile_leaderboard' },
            ckmobile_300x250_top: { publisherId: 'OZONECIA0001', siteId: '1500000960', placementId: '3500024043', gpid: '/1010633/ckmobile_300x250_top' },
            ckmobile_300x250: { publisherId: 'OZONECIA0001', siteId: '1500000960', placementId: '3500024042', gpid: '/1010633/ckmobile_300x250' },
            ckmobile_fplayer: { publisherId: 'OZONECIA0001', siteId: '1500000960', placementId: '3500024045', gpid: '/1010633/ckmobile_fplayer' },
            ckmobile_300x250_bottom: { publisherId: 'OZONECIA0001', siteId: '1500000960', placementId: '3500024044', gpid: '/1010633/ckmobile_300x250_bottom' },
            //  Kodami
            kodami_header: { publisherId: 'OZONECIA0001', siteId: '1500000959', placementId: '3500024036', gpid: '/1010633/kodami_header' },
            kodami_top: { publisherId: 'OZONECIA0001', siteId: '1500000959', placementId: '3500024033', gpid: '/1010633/kodami_top' },
            kodami_middle: { publisherId: 'OZONECIA0001', siteId: '1500000959', placementId: '3500024034', gpid: '/1010633/kodami_middle' },
            kodami_low: { publisherId: 'OZONECIA0001', siteId: '1500000959', placementId: '3500024035', gpid: '/1010633/kodami_low' },
            kodami_bottom: { publisherId: 'OZONECIA0001', siteId: '1500000959', placementId: '3500024037', gpid: '/1010633/kodami_bottom' },
        },
        video: {
            fanpage_video: { publisherId: 'OZONECIA0001', siteId: '1500000956', placementId: '3500024012', gpid: '/1010633/fanpage/video' },
            ck_it_video: { publisherId: 'OZONECIA0001', siteId: '1500000957', placementId: '3500024021', gpid: '/1010633/cookistit/video' },
            ck_wow_video: { publisherId: 'OZONECIA0001', siteId: '1500000960', placementId: '3500024047', gpid: '/1010633/cookistcom/video' },
            ck_legal_video: { publisherId: '', siteId: '', placementId: '', gpid: '/1010633/cookistlegal/video' },
            ohga_video: { publisherId: '', siteId: '', placementId: '', gpid: '/1010633/ohga/video' },
            kodami_video: { publisherId: 'OZONECIA0001', siteId: '1500000959', placementId: '3500024039', gpid: '/1010633/kodami/video' },
            geopop_video: { publisherId: 'OZONECIA0001', siteId: '1500000958', placementId: '3500024030', gpid: '/1010633/geopop/video' },
            wamily_video: { publisherId: '', siteId: '', placementId: '', gpid: '/1010633/wamily/video' },
            lexplain_video: { publisherId: '', siteId: '', placementId: '', gpid: '/1010633/lexplain/video' },
        }
    }
}